var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-office"},[_c('back-office-aside'),_c('back-office-main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }